import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { TrendingUp, CheckCircle2, Clock, Star } from "lucide-react";

export default function Rentabilite() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  useEffect(() => { if (user?.role === "pro") api.get("/stats/pro").then((r) => setStats(r.data)); }, [user]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="rentabilite-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">Rentabilité</div>
          <h1 className="font-display font-extrabold text-3xl text-slate-900 tracking-tight">Performance dépanneur</h1>

          {stats && (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
              <Stat label="CA" value={`${stats.revenue_eur.toFixed(0)} €`} icon={TrendingUp} accent />
              <Stat label="Offres acceptées" value={stats.accepted_offers} icon={CheckCircle2} />
              <Stat label="Taux d'acceptation" value={`${stats.win_rate}%`} icon={Clock} />
              <Stat label="Note" value={stats.rating_avg ? `${stats.rating_avg}/5` : "—"} icon={Star} />
            </div>
          )}

          <div className="mt-6 bg-white border border-slate-200 rounded-md p-6">
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold mb-1">Conseils</div>
            <h2 className="font-display font-bold text-xl text-slate-900">Maximisez votre rentabilité</h2>
            <ul className="mt-3 space-y-2 text-sm text-slate-700">
              <li>• Filtrez le marketplace par axes géographiques que vous connaissez.</li>
              <li>• Utilisez le <strong>matching aller/retour</strong> pour cumuler deux missions compatibles.</li>
              <li>• Répondez rapidement aux demandes urgentes : vos offres y sont plus acceptées.</li>
              <li>• Maintenez une note ≥ 4.5/5 pour apparaître en priorité.</li>
            </ul>
          </div>
        </main>
      </div>
    </div>
  );
}

function Stat({ label, value, icon: Icon, accent }) {
  return (
    <div className={`rounded-md border p-5 ${accent ? "bg-slate-900 text-white border-slate-800" : "bg-white border-slate-200"}`}>
      <div className="flex items-center justify-between">
        <div className={`text-[10px] uppercase tracking-widest font-bold ${accent ? "text-orange-400" : "text-slate-500"}`}>{label}</div>
        <Icon className={`h-4 w-4 ${accent ? "text-orange-400" : "text-slate-400"}`} />
      </div>
      <div className={`font-display font-extrabold text-3xl mt-2 ${accent ? "text-white" : "text-slate-900"}`}>{value}</div>
    </div>
  );
}
